import type { THomeLoanType } from '~/interfaces';

export const HomeLoanType: { label: string; value: THomeLoanType }[] = [
  { label: 'Purchase', value: 'mortgage' },
  { label: 'Refinance', value: 'refinance' },
  { label: 'Home Equity', value: 'home-equity' },
] as const;
